import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import RecommandBasedOnKnownCrops from "./RecommandBasedOnKnownCrops";
import RecommandBasedOnSoilClimate from "./RecommandBasedOnSoilClimate";

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    fontFamily: "'Poppins', sans-serif",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    color: "white",
    padding: "10px 20px",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 1000,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(5px)",
  },
  mainContent: {
    flex: 1,
    marginTop: "60px", // Adjust to leave space for the fixed header
    overflowY: "auto", // Enable vertical scrolling
    padding: "20px",
  },
  welcomeMessage: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: "#fff",
    marginRight: "20px",
  },
  profileImageWrapper: {
    position: "relative",
    cursor: "pointer",
  },
  profileImage: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    border: "2px solid #fff",
  },
  dropdown: {
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    padding: "10px 0",
    zIndex: 1001,
  },
  dropdownItem: {
    padding: "10px 20px",
    color: "#333",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background-color 0.3s",
  },
  dropdownItemHover: {
    backgroundColor: "#f0f0f0",
  },
};

const DashBoard = ({ user, onSignOut }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const dropdownRef = useRef(null); // Reference for the dropdown menu
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMenuOpen(false); // Close the menu if clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSignOut = async () => {
    try {
      await onSignOut();
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Sign-out error: ", err.message);
    }
  };

  const navigationLinks = [
    { label: "Profile", path: "/profile" },
    { label: "NPK Update", path: "/npk" },
    { label: "My Crops", path: "/manage-crops" },
    { label: "Sow Crop", path: "/add" },
    { label: "Sowed Crops", path: "/my-sowing" },
    { label: "Total Demand", path: "/demand" },
    { label: "Crops Description", path: "/crop-list" },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.welcomeMessage}>
          Welcome, {user.displayName || "Guest"}
        </span>

        <div
          style={styles.profileImageWrapper}
          onClick={() => setIsMenuOpen((prev) => !prev)}
          ref={dropdownRef}
        >
          <img
            src={user.photoURL || "https://via.placeholder.com/40"}
            alt="Matops Grow User Profile Image"
            style={styles.profileImage}
          />
          {isMenuOpen && (
            <div style={styles.dropdown}>
              {navigationLinks.map((link, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.dropdownItem,
                    ...(hoveredItem === index ? styles.dropdownItemHover : {}),
                  }}
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() => navigate(link.path)}
                >
                  {link.label}
                </div>
              ))}
              <div
                style={{
                  ...styles.dropdownItem,
                  ...(hoveredItem === "signout"
                    ? styles.dropdownItemHover
                    : {}),
                }}
                onMouseEnter={() => setHoveredItem("signout")}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={handleSignOut}
              >
                Sign Out
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={styles.mainContent}>
        <RecommandBasedOnKnownCrops email={user.email} />
        <RecommandBasedOnSoilClimate email={user.email} />
      </div>
    </div>
  );
};

export default DashBoard;
